'use strict';

function map(f, as) {
  return Array.from(as).map(f);
}

module.exports = map;
